export default __webpack_public_path__ + "static/media/Reports.f05aa37b.svg";